import { useCompletedTask } from '@/pages/home/hooks/useCompletedTask';
import { GENERATED, type HomePage } from '@edwin-group/cj-graphql';
import { useNavigate } from 'react-router-dom';

export const DailyCardCharacterCompass = ({ page }: { page: HomePage | null }) => {
  const navigate = useNavigate();
  const { isCompleted } = useCompletedTask({
    type: GENERATED.Enum_Completedtask_Type.CharacterCompass,
  });

  const section = page?.cardsSection?.characterCompass || {
    title: '',
    description: '',
    ctaBtn: '',
    completedBtn: '',
  };

  const onClick = () => {
    navigate('/character-compass');
  };

  return (
    <div className="flex h-full flex-col items-center gap-sh-15 rounded-2xl bg-[#F1D55C] p-5  text-center text-[#4B7EEA]">
      <h2 className="font-aTypeStencil text-sh-24-22 ">
        <span>{section.title}</span>
      </h2>
      <p className="font-cadiz text-sh-xxs">{section.description}</p>
      <button type="button" className="font-cadiz text-sh-xxs font-bold hover:opacity-50" onClick={onClick}>
        {!isCompleted ? section.ctaBtn : section.completedBtn}
      </button>
    </div>
  );
};
